<script lang="ts">
  import type { BreadcrumbItems } from "./type";
  import Icon from "../icons/Icon.svelte";

  export let items: BreadcrumbItems[] = [];
</script>

<nav>
  <ol class="flex flex-row flex-wrap list-none">
    {#each items as item, index}
      <li class="breadcrumb-item">
        <a
          href={item.href}
          class:current-page={item.current}
          disabled={item.current}
          on:click={(event) => {
            if (item.current) {
              event.preventDefault();
            }
          }}
          tabindex={item.current ? -1 : 0}
        >
          {#if index === 0}
            <div class="breadcrumb-rounded-tail" />
          {:else}
            <div class="breadcrumb-tail">
              <div>
                <Icon icon="breadcrumb" width="466px" height="32px" />
              </div>
            </div>
          {/if}

          <div class="breadcrumb-content">
            <div class="place-holder">{item.label}</div>
            <div class="content">{item.label}</div>
          </div>

          <div class="breadcrumb-head">
            <div>
              <Icon icon="breadcrumb" width="466px" height="32px" />
            </div>
          </div>
        </a>
      </li>
    {/each}
  </ol>
</nav>

<style lang="postcss">
  ol {
    --breadcrumb-animation-duration: 0.2s;
    --breadcrumb-animation-function: ease-in-out;
  }

  ol,
  ol li {
    @apply relative text-dark-50;
    max-width: 100%;
    font-size: 13px;
  }

  ol li {
    @apply mb-1;
  }

  a {
    @apply relative flex flex-row items-center flex-nowrap px-0 ml-0 -mr-0.5 my-0;
    height: 32px;
    z-index: 1;
  }

  .breadcrumb-rounded-tail {
    @apply relative bg-light-100 bg-opacity-30;
    height: 32px;
    width: 20px;
    border-radius: 3px 0px 0px 3px;
  }

  .breadcrumb-tail,
  .breadcrumb-head {
    @apply text-light-100 text-opacity-30 overflow-hidden;
    width: 24px;
    height: 32px;
  }

  .breadcrumb-tail {
    @apply flex flex-row items-center justify-start;
  }

  .breadcrumb-head {
    @apply flex flex-row items-center justify-end;
  }

  /* current page style */
  a.current-page {
    @apply text-dark-100 font-medium pointer-events-none;
  }

  .current-page .breadcrumb-content,
  .current-page .breadcrumb-rounded-tail {
    @apply bg-opacity-70;
  }

  .current-page .breadcrumb-tail,
  .current-page .breadcrumb-head {
    @apply text-opacity-70;
  }

  a:hover .breadcrumb-content,
  a:hover .breadcrumb-rounded-tail {
    @apply bg-white bg-opacity-100;
  }

  a:hover .breadcrumb-tail,
  a:hover .breadcrumb-head {
    @apply font-medium text-white text-opacity-100;
  }

  .breadcrumb-content {
    @apply flex flex-row items-center bg-light-100 bg-opacity-30;
    height: 32px;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  .breadcrumb-content .content {
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 20px;
  }

  .breadcrumb-content {
    @apply relative;
  }

  .breadcrumb-content .content {
    @apply absolute left-0 right-0;
  }

  .breadcrumb-content .place-holder {
    @apply opacity-0;
  }

  a:hover .breadcrumb-content .content,
  .breadcrumb-content .place-holder {
    @apply text-dark-200 font-medium;
  }

  /* box shadow on hover */
  a::before,
  a::after,
  .breadcrumb-rounded-tail::before {
    box-shadow: none;
    content: "";
    z-index: -1;
    transition: box-shadow var(--breadcrumb-animation-duration)
      var(--breadcrumb-animation-function);
  }

  a::before,
  a:after {
    @apply absolute bg-transparent rounded pointer-events-none;
    left: 4px;
    right: 6px;
  }

  a::before {
    top: 0;
    bottom: 50%;
    transform: skew(26deg);
  }

  a::after {
    top: 50%;
    bottom: 0;
    transform: skew(-26deg);
  }

  a:hover::before {
    box-shadow: 0px 4px 10px rgba(55, 84, 170, 0.12);
  }

  a:hover::after {
    box-shadow: 4px 2px 10px rgba(55, 84, 170, 0.2),
      -2px 2px 10px rgba(55, 84, 170, 0.12);
  }

  a .breadcrumb-rounded-tail::before {
    @apply absolute top-1 bottom-0.5 left-0 right-0 pointer-events-none;
  }

  a:hover .breadcrumb-rounded-tail::before {
    box-shadow: -2px 0px 10px rgba(55, 84, 170, 0.06);
  }

  /* content animation */
  .breadcrumb-content,
  .breadcrumb-rounded-tail,
  .breadcrumb-tail,
  .breadcrumb-head,
  .breadcrumb-content .content {
    transition: background-color var(--breadcrumb-animation-duration)
        var(--breadcrumb-animation-function),
      color var(--breadcrumb-animation-duration)
        var(--breadcrumb-animation-function),
      font-weight var(--breadcrumb-animation-duration)
        var(--breadcrumb-animation-function);
  }
</style>
